<template>
    <div class="ChangeLoginPassword">
         <el-dialog
            :title="title + $t('myAccount.text104')"
            v-model="changeLoginPasswordModelFlag"
            width='500px'
            :close-on-click-modal="false"
            destroy-on-close
            @closed="beforeClose"

        >
            <PasswordInputBox 
                :blurFunc="oldPwdBlur" 
                :value="paramsData.oldPwd"
                :placeholder="$t('myAccount.text106')"
            />
            <PasswordInputBox 
                :blurFunc="newPwdBlur" 
                :value="paramsData.newPwd"
                :placeholder="$t('signUp.text31')"
                :errorFlag="errorFlag"
                :errText="$t('signUp.text33')"
            />
            <PasswordInputBox 
                :blurFunc="newPwd2Blur" 
                :value="paramsData.newPwd2"
                :placeholder="$t('signUp.text32')"
            />
            <template #footer>
                <span class="dialog-footer">
                <div class="forget" @click="forgetModerFlag">
                    {{$t('trade.text124')}}
                </div>
                <el-button @click="cancel">{{$t('trade.text72')}}</el-button>
                <el-button type="primary" :loading='loading' :disabled="!submitFlag" @click="Confirm"
                    >{{$t('trade.text73')}}</el-button>
                </span>
            </template>
         </el-dialog>
    </div>
</template>
<script>
import {
  ref,reactive,computed,inject,onBeforeUnmount
} from 'vue';
import apiService from '@/api/request';
import { ElMessage } from 'element-plus'
import { useI18n } from "vue-i18n";

export default {
    name:'ChangeLoginPassword',
    setup(){
        const emitt = inject('emitt');
        const { t } = useI18n()
        
        const changeLoginPasswordModelFlag = ref(false);
        const loading = ref(false);
        const paramsData = reactive({
            oldPwd:'',
            newPwd:'',
            newPwd2:''
        })
        const errorFlag = ref(false);//密码错误提示
        const title = ref('');


        function cancel(){
            changeLoginPasswordModelFlag.value = false;
            errorFlag.value = false;
        }
        /**
         * 打开弹框-开始
         */ 
          emitt.$sub('openChangeLoginPassword', (val) => {
            title.value = val[0].title;
            changeLoginPasswordModelFlag.value = true;
          });
          onBeforeUnmount(() => {
            emitt.$unsub("openChangeLoginPassword");
          });
        /**
         * 打开弹框-开始
         */ 

         /**
         * 组件赋值操作-开始
         */
            function oldPwdBlur(val) {
                paramsData.oldPwd = val;
            }
            function newPwdBlur(val) {
                errorFlag.value = false;
                paramsData.newPwd = val;
            }
            function newPwd2Blur(val) {
                errorFlag.value = false;
                paramsData.newPwd2 = val;
            }
        
        /**
         * 组件赋值操作-结束
         */

         /**
         * 手机验证按钮提交条件-开始
         */
            const submitFlag = computed(() => {
                return  paramsData.oldPwd != "" && 
                        paramsData.newPwd != "" && 
                        paramsData.newPwd2 != "" 
            })
        /**
         * 手机验证按钮提交条件-结束
         */

        /**
         * 提交修改-开始
         */
            function Confirm(){
                if(paramsData.newPwd !== paramsData.newPwd2){
                    errorFlag.value = true;
                    return
                }
                 let mask = /^[\da-z]+$/i
                if(!mask.test(paramsData.newPwd)){
                    ElMessage({
                        message: t('signUp.text37'),
                        type: 'error',
                        })
                    return
                }
                let params = {
                    oldPwd:window.btoa(paramsData.oldPwd),
                    newPwd:window.btoa(paramsData.newPwd)
                }
                loading.value = true;
                apiService.ModifyPassword(params).then(res => {
                    console.log(res)
                    if(res.status == 1){
                        changeLoginPasswordModelFlag.value = false;
                        ElMessage({
                            message: t('myAccount.text107'),
                            type: 'success',
                        });
                        store.dispatch('getUserStatus');
                    }else{
                         ElMessage({
                            message: res.message,
                            type: 'error',
                        });
                    }
                    loading.value = false;
                })
            }
        /**
         * 提交修改-开始
         */

        /**
         * 忘记密码-开始
         */
            function forgetModerFlag(){
                changeLoginPasswordModelFlag.value = false;
                
                emitt.$pub('openSetLoginPassword',{title:t('myAccount.text11')});
            }
        /**
         * 忘记密码-结束
         */

         /**
         * 关闭弹框-开始
         */
            function beforeClose(){
                paramsData.oldPwd = '';
                paramsData.newPwd = '';
                paramsData.newPwd2 = '';
                errorFlag.value = false;
            }
        /**
         * 关闭弹框-结束
         */
        return {
            changeLoginPasswordModelFlag,
            oldPwdBlur,
            paramsData,
            newPwd2Blur,
            newPwdBlur,
            submitFlag,
            loading,
            Confirm,
            errorFlag,
            forgetModerFlag,
            cancel,
            beforeClose,
            title
        }
    }
}
</script>
<style lang="less" scoped>
.ChangeLoginPassword{
    .dialog-footer{
        .forget{
            width: 150px;/*no*/
            height: 32px;/*no*/
            text-align: center;
            line-height: 32px;/*no*/
            background: @heading-bg-color;
            color: @primary-color;
            font-size: 14px;/*no*/
            display: inline-block;
            float: left;
            cursor: pointer;
        }
    }
}
</style>
